import { dataSchemaToTSDeclaration } from '@tencent/data-schema-core/lib/convertor/typescript';
import { DBDatasourceMethods, FilterOperators, filterOperatorsMap, LogicOperator, } from './types/DBSource';
import { requestCGI } from './requestCGI';
import { DataSourceBase } from './DataSourceBase';
import commonTSDeclaration from '!!raw-loader!./types/DBSource.d.ts';
import { IDataSourceTypes } from './types/ICollection';
export class DBSource extends DataSourceBase {
    static getCommonTSDeclaration() {
        return commonTSDeclaration;
    }
    filterSeparator = '__';
    async getTSDeclaration(typePrefix = 'DataSource_') {
        const { entity } = await this.getCollectionInfo();
        const entityTS = dataSchemaToTSDeclaration(entity, {});
        return `type ${typePrefix}${this.collectionId} = DBObject<${entityTS.exportedTypeId}>;\n${entityTS.getFullCode()}`;
    }
    async getMethods() {
        return {
            create: this.create.bind(this),
            update: this.update.bind(this),
            delete: this.delete.bind(this),
            getById: this.getById.bind(this),
            query: this.query.bind(this),
            count: this.count.bind(this),
        };
    }
    async create(data) {
        const response = await requestCGI(this.collectionId, DBDatasourceMethods.create, {
            body: data,
        }, {});
        return response.data.data;
    }
    async update(id, data) {
        const { type } = await this.getCollectionInfo();
        // 多表数据源, 需要传入oldData
        if (type === IDataSourceTypes.ER) {
            const oldData = await this.getById(id);
            const response = await requestCGI(this.collectionId, DBDatasourceMethods.update, {
                query: { id },
                body: {
                    oldData,
                    // 接口要求传入所有字段
                    newData: {
                        ...oldData,
                        ...data,
                    },
                },
            }, {});
            return response.data.data;
        }
        const response = await requestCGI(this.collectionId, DBDatasourceMethods.update, {
            query: { id },
            body: data,
        }, {});
        return response.data.data;
    }
    async delete(id) {
        const response = await requestCGI(this.collectionId, DBDatasourceMethods.delete, {
            query: { id },
        }, {});
        return response.data.data;
    }
    async getById(id) {
        const response = await requestCGI(this.collectionId, DBDatasourceMethods.get, {
            query: { id },
        }, {});
        return response.data.data;
    }
    async query(params) {
        const filter = this.parseFilter(params?.filter);
        const { sort, order } = this.parseSort(params?.sort);
        const response = await requestCGI(this.collectionId, DBDatasourceMethods.list, {
            query: {
                filter,
                sort,
                order,
                page: params?.page,
                size: params?.pageSize,
            },
        }, {});
        return response.data.data;
    }
    async count(params) {
        const filter = this.parseFilter(params?.filter);
        const response = await requestCGI(this.collectionId, DBDatasourceMethods.count, {
            query: { filter },
        }, {});
        return response.data.data.total;
    }
    parseFilter(filter, parentOperator = '&') {
        if (!filter)
            return;
        const parts = [];
        Object.entries(filter).forEach(([key, value]) => {
            if ([LogicOperator.AND, LogicOperator.OR].includes(key)) {
                const logicOperator = key === LogicOperator.AND ? '&' : '|';
                const subQuery = value
                    .map(subFilter => `(${this.parseFilter(subFilter)})`)
                    .join(logicOperator);
                parts.push(subQuery);
            }
            else {
                const lastUnderscoreIndex = key.lastIndexOf(this.filterSeparator);
                let field = key;
                // 默认操作符为等于
                let operator = filterOperatorsMap[FilterOperators.eq];
                if (lastUnderscoreIndex !== -1) {
                    field = key.slice(0, lastUnderscoreIndex);
                    operator = filterOperatorsMap[key.slice(lastUnderscoreIndex + this.filterSeparator.length)];
                }
                if (!operator) {
                    throw new Error(`Unsupported filter operator: ${key}`);
                }
                parts.push(`${field}${operator}${JSON.stringify(value)}`);
            }
        });
        return parts.join(parentOperator);
    }
    parseSort(sortString) {
        if (!sortString)
            return {};
        const sort = [];
        const order = [];
        sortString.split(',').forEach((field) => {
            if (field.startsWith('-')) {
                sort.push(field.slice(1));
                order.push('desc');
            }
            else {
                sort.push(field);
                order.push('asc');
            }
        });
        return {
            sort: sort.join(','),
            order: order.join(','),
        };
    }
}
